import { UserManager, WebStorageStateStore } from "oidc-client";
import { API_BASE_URL } from "../../config";
import { clearAllCookies } from "../extensions/clearAllCookies";

// Ensures the base URL uses HTTPS. If it starts with HTTP, switch to HTTPS.
const ensureHttps = (url: string): string => {
  if (!url) return url;
  return url.startsWith("http://")
    ? "https://" + url.slice("http://".length)
    : url;
};

const config = {
  authority: ensureHttps(API_BASE_URL) + "/api",
  redirect_uri: `${window.location.origin}/authorize-redirect`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: "openid profile email api1 offline_access openid",
  loadUserInfo: true,
  response_mode: "query",
  client_id: "timeplannedclient",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  sessionMonitor: false,
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTime: 10,
};

const userManager = new UserManager(config);

userManager.events.addSilentRenewError((error) => {
  console.error("Silent renew error:", error);
  window.location.href = "/login";
});

userManager.events.addAccessTokenExpiring(() => {
  refreshToken();
});

const refreshToken = async () => {
  try {
    const user = await userManager.getUser();
    if (user) {
      await userManager.signinSilent();
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    window.location.href = "/login";
  }
};
export const login = async (provider: "Google" | "Microsoft" | "Apple") => {
  try {
    clearAllCookies();
    const scopes = "openid profile email api1 offline_access openid";
    await userManager.signinRedirect({
      extraQueryParams: { prompt: "login", provider: provider },
      scope: scopes,
    });
  } catch (error) {
    throw error;
  }
};

export const getUser = () => userManager.getUser();

export const completeSignIn = async () => {
  try {
    await userManager.signinRedirectCallback();
  } catch (error) {
    throw error;
  }
};

export default userManager;
